<template>
	<div class="app-button-container">
		<router-link :aria-label="label"
		             :class="buttonClasses"
		             :tabindex="0"
		             :to="to"
		             class="app-button"
		             role="button"
		             v-if="to && enabled"
		             v-on:click.prevent="$emit('onClick')"
		             v-on:keyup.space="$emit('onClick')">
			<span class="app-button-text"><slot></slot></span>
		</router-link>
		<button :aria-label="label"
		        :class="buttonClasses"
		        :tabindex="0"
		        class="app-button"
		        role="button"
		        v-else
		        v-on:click.prevent="$emit('onClick')"
		        v-on:keyup.space="$emit('onClick')">
			<span class="app-button-text"><slot></slot></span>
		</button>
	</div>
</template>

<script>
	export default {
		name: 'app-button',
		props: {
			to: {
				type: String
			},
			enabled: {
				type: Boolean,
				default: true
			},
			buttonStyle: {
				type: String,
				default: 'primary' //primary / secondary
			}
		},
		computed: {
			label() {
				return '';
			},
			buttonClasses() {
				let classes = [];

				classes.push(this.buttonStyle);
				classes.push(this.enabled ? 'enabled' : 'disabled');

				return classes;
			}
		}
	}
</script>
<style lang="less" scoped>
	@import "~@less/font-sizes.less";
	@import "~@less/mixins/mixins.less";
	@import "~@less/variables.less";

	.app-button-container {
		position: relative;
		width: auto;
		display: inline-block;

		&.selected .app-button {
			box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.6);
			pointer-events: none;

			span::before {
				padding-right: 8px;
				content: ">";
			}
		}
	}

	@app-button-width: 190px;
	@app-button-height: 38px;

	.app-button {
		cursor: pointer;
		width: @app-button-width;
		height: @app-button-height;
		border-radius: 999px;
		background-color: @roskilde-blue;
		color: white;
		text-align: center;
		font-size: @app-font-size-button;
		display: inline-block;
		transition: all 0.2s ease-in-out;
		padding-top: 3px;
		outline: 0;
		border: 0;

		&.disabled {
			opacity: .3;
			cursor: not-allowed;
		}

		&:focus, &:hover {
			text-decoration: none;
			background-color: darken(@roskilde-blue, 10%);
		}

		&:active {
			background-color: darken(@roskilde-blue, 10%) !important;
		}

		span {
			line-height: @app-button-height;
			position: relative;
			bottom: 3px;
			font-weight: 700;
		}
	}

	.media-lg({
		.app-button {
			width: @app-button-width * @size-percentage-lg;
			height: @app-button-height * @size-percentage-lg;

			span {
				line-height: @app-button-height * @size-percentage-lg;
			}
		}
	});

	.media-xl({
		.app-button {
			width: @app-button-width * @size-percentage-xl;
			height: @app-button-height * @size-percentage-xl;

			span {
				line-height: @app-button-height * @size-percentage-xl;
			}
		}
	});

	.media-xxl({
		.app-button {
			width: @app-button-width * @size-percentage-xxl;
			height: @app-button-height * @size-percentage-xxl;

			span {
				line-height: @app-button-height * @size-percentage-xxl;
			}
		}
	});
</style>
